// extracted by mini-css-extract-plugin
export default {"label":"label_label__wotHB","bold":"label_bold__aIYJ5","icon":"label_icon__Wt3Cm"};